import React from "react";
import { useForm, SubmitHandler, Controller } from "react-hook-form";
import EATextField from "../shared/TextField/EATextField";
import EAButton from "../shared/Buttons/EAButton";
import EABirthDateInput from "../shared/BirthDateInput/EABirthDateInput";
import { Child } from "../../models/ParticipantRegistration";
import { useTranslation } from "react-i18next";
import { LENGTH_VALIDATOR } from "../../../messages/errorsMessages";
import "./style.scss";

interface IProps {
  onSave: (child: Child) => void;
  onCancel?: () => void;
  initialData?: Child;
  isEditing?: boolean;
  newsletterAgreement: boolean;
}

const ChildForm: React.FC<IProps> = ({ onSave, onCancel, initialData, isEditing = false, newsletterAgreement }) => {
  const { t } = useTranslation();

  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
  } = useForm<Child>({
    defaultValues: initialData
      ? {
          name: initialData.name,
          lastName: initialData.lastName,
          birthDate: initialData.birthDate,
          newsletterAgreement: initialData.newsletterAgreement,
        }
      : {
          name: "",
          lastName: "",
          birthDate: null as any,
          newsletterAgreement: newsletterAgreement,
        },
  });

  const handleSaveChild: SubmitHandler<Child> = (data) => {
    onSave({
      name: data.name,
      lastName: data.lastName,
      birthDate: data.birthDate,
      newsletterAgreement,
    });
  };

  return (
    <form onSubmit={handleSubmit(handleSaveChild)} className="child-form">
      <div className="flex-start-center flex-wrap">
        <EATextField
          name="name"
          label={t("imie")}
          placeholder={t("imie")}
          error={!!errors.name}
          helperText={errors.name?.message as string}
          fullWidth
          register={{
            ...register("name", {
              required: t("to_pole_jest_wymagane"),
              minLength: { value: 2, message: LENGTH_VALIDATOR(t, 2) },
            }),
          }}
        />
        <EATextField
          name="lastName"
          label={t("nazwisko")}
          placeholder={t("nazwisko")}
          error={!!errors.lastName}
          helperText={errors.lastName?.message as string}
          fullWidth
          register={{
            ...register("lastName", {
              required: t("to_pole_jest_wymagane"),
              minLength: { value: 2, message: LENGTH_VALIDATOR(t, 2) },
            }),
          }}
        />
        <Controller
          name="birthDate"
          control={control}
          rules={{
            validate: (value) => {
              if (!value) return t("pole_wymagane");
              if (isNaN((value as Date).getTime())) return t("niepoprawna_data");
              if (value > new Date()) return t("data_nie_moze_byc_z_przyszlosci");
              return true;
            },
          }}
          render={({ field }) => (
            <EABirthDateInput
              label={t("data_urodzenia")}
              name="birthDate"
              field={field}
              error={!!errors.birthDate}
              helperText={errors.birthDate?.message as string}
              fullWidth
            />
          )}
        />
      </div>

      <div className="child-form__buttons">
        <EAButton title={isEditing ? t("zapisz_zmiany") : t("dodaj_uczestnika")} inputType="submit" variant="filled" />
        {onCancel && <EAButton title={t("anuluj")} onClick={onCancel} variant="outlined" />}
      </div>
    </form>
  );
};

export default ChildForm;
